const CloseIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M17.3732 2.62695L10.0001 10.0001L2.62695 2.62695" stroke="currentColor" strokeWidth="2" />
    <path d="M17.3732 17.373L10.0001 9.99991L2.62695 17.373" stroke="currentColor" strokeWidth="2" />
  </svg>
);

export default CloseIcon;
